import React from 'react'
import PropTypes from 'prop-types'

const FontItalicControl = ({ canvas, active, disabled }) => {
  const activeClass = active ? 'active' : ''
  const disabledClass = disabled ? 'disabled' : ''

  const toggleItalic = () => {
    const obj = canvas.getActiveObject()
    const isDefault = obj.fontStyle !== 'italic'

    obj.set('fontStyle', isDefault ? 'italic' : 'normal')
      .exitEditing()

    canvas.renderAll()
  }

  return (
    <div
      className={`letterHeaderTools_action icon icon-italic ${activeClass} ${disabledClass}`}
      onClick={toggleItalic} />
  )
}

FontItalicControl.propTypes = {
  canvas: PropTypes.object,
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
}

export default FontItalicControl
